import { IonButtons, IonContent, IonHeader, IonItem, IonLabel, IonMenuButton, IonPage, IonToolbar, IonButton
,IonList, IonSearchbar, IonDatetimeButton,IonModal
,IonThumbnail
,IonDatetime
} from '@ionic/react';
//import { useParams } from 'react-router';
import './WpWork.css';
import OpenMenuButton from "../../../components/OpenMenuButton";
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import ServerService from '../../../services/Server';
import { useHistory } from 'react-router-dom';
import { format } from 'path';
type WpFormParams = {
  id:string, 
  dummy:string
}
  const WpWork: React.FC = () => {
  const {id, dummy} = useParams<WpFormParams>();
  const server = new ServerService();
  const history = useHistory();
  server.setHistory(history);
  const [workList, setWorkList] = useState([]);
  const [workDate, setWorkDate] = useState("");
  const [textSearch, setTextSearch] = useState("");
  const [toDay, setToDay] = useState(new Date().toISOString().substring(0, 10)+"T00:00:00.000+00:00");
  
  const onSelectDate = async function(date:any) {
    console.log(date.target.value);
    setToDay(date.target.value);
    setWorkDate(date.target.value);
    fetchWork(date.target.value, textSearch);
  }
  const onSearch = async function(txt:any) {
    console.log(txt.target.value);
    setTextSearch(txt.target.value);
    fetchWork(workDate, txt.target.value);
   
    //2023-06-13T13:59:04.470+07:00
    console.log(new Date().toISOString().substring(0, 10)+"T00:00:00.000+00:00");
    //fetchWork(date.target.value);
  }
  const data = {
    docid: id
  }
  const onDownloadWork = function(id:any, jsaId:any) {

    window.open(server.getFullUrl("wp/exportWork?alf_ticket="+server.state.ticket+"&jsa_id="+jsaId+"&permit_id="+id, null));
   
  }
  useEffect(() => {
    fetchWork(toDay, "");
  }, [])
  
  const fetchWork = function(date:any, search:any) {
    const param = {
      workDate: date,
      searchTerm : search
    }
    fetch(server.getFullUrl("wp/mb/listMobileWorkPermit", param),server.getRequest())
    .then(res => res.json()
    .then(
      (result) => {
        setWorkList(result.data);
        console.log('fetchWork');
      },
      (error) => {
  
      }
   ).catch(e => {
  
   })
  ).catch(e => {
  
  }) 
  }
  return (
    <IonPage>

      <IonHeader>
        <IonToolbar>    
          <IonButtons slot="start">
            <IonMenuButton />
            <OpenMenuButton />
          </IonButtons>      
         <div className="mydiv">
          <img className="workImg1" src={"assets/img/document.png"}/> 
          <span className="myspan">  WorkPermit</span>
         </div>
        </IonToolbar>
      </IonHeader>
     
      <IonContent>
        <IonToolbar>
          <IonSearchbar onIonInput={e => {onSearch(e)}}></IonSearchbar>
          <IonItem>
            <IonLabel>Work Date</IonLabel>  
            <IonDatetimeButton  datetime="workDate"></IonDatetimeButton>        
          </IonItem>
         
        </IonToolbar>

        <IonList>
       

      <IonModal keepContentsMounted={true}>
        <IonDatetime showDefaultButtons={true} presentation='date' value={toDay}  onIonChange={e => {onSelectDate(e)}} id="workDate"></IonDatetime>
      </IonModal>

    {workList.map((task,i) => {
          return(
            <IonItem key={i}>
            <IonThumbnail slot="start">
              <img alt={task.permit_id} src={"assets/img/"+task.img+".png"} />
            </IonThumbnail>
            <IonLabel class="ion-text-wrap">{task.permit_id} {"->"} {task.companyname} {"->"} {task.task} {"->"} {task.status_name}</IonLabel>     
            <IonButton onClick={() => onDownloadWork(task.permit_id,task.jsa_id)} key={i} fill={"clear"}> <img className="img1" src={"assets/img/pdf-document.png"} />&nbsp;PDF</IonButton>    
          </IonItem>
           
    )})}
    </IonList>
      </IonContent>

    </IonPage>
  );
};

export default WpWork;
